<!--
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-09-19 18:54:13
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-09-19 23:04:23
-->

<template>
  <div class="main">
    <div class="content" v-html="content" />
  </div>
</template>

<script>
import { privacy, use, promote } from '@/utils/promise'
import {promotion} from "../utils/promotion";

export default {
  name: 'Promise',
  data() {
    return {
      content: promote
    }
  },
  mounted() {
      document.title = '用户协议'
      // this.content =use + promote+ privacy
      this.content = promotion
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: 30px;
  background: #ffffff;
  .content {
    display: flex;
    flex-direction: column;
  }
}
</style>

<style>
.tip {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 40px;
}

h2{
  padding: 15px 0;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  font-weight: bold;
  line-height: 50px;
}

h1{
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  font-weight: bold;
  line-height: 60px;
}

h3{
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  font-weight: bold;
  line-height: 50px;
}

p{
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 40px;
}

.bottom{
  margin-top: 30px;
  line-height: 50px;
}

header{
  text-align: center;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: 500;
  font-weight: bold;
  line-height: 100px;
}

h4,h6{
  margin: 0;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 60px;
}

h6{
  line-height: 80px;
}

h5{
  padding: 30px 0;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  font-weight: bold;
  line-height: 80px;
}
</style>
